/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Vue 設定
import Vue from "vue";
import VueI18n from "vue-i18n";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueLodash, { lodash: lodash });
Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// Vue-moment 設定 - 需要引入翻譯檔
const moment = require("moment");
require("moment/locale/zh-tw");
moment.updateLocale(moment.locale(), { invalidDate: "N/A" });
Vue.use(require("vue-moment"), { moment });

// // 發送 ajax 時要帶著 token
let token = document.head.querySelector('meta[name="_csrf_token"]');
if (token) {
    Vue.prototype.$http.defaults.headers.common["RequestVerificationToken"] =
        token.content;
} // end of if

("use strict");
